import { screenSizes } from "@storeblocks/global-styles";
import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 24px 0px;

  button:nth-child(2) {
    margin-left: 16px;
  }

  @media only screen and (max-width: ${screenSizes.desktop}px) {
    flex-direction: column;

    button:nth-child(2) {
      margin-left: 0px;
      margin-top: 8px;
    }
  }
`;
